import * as type from './mutation-types'
const setPeriodo = async ({commit},{periodoId, centroCustoId}) => {
  const {data : periodo } = await axios.get(`/api/v1/painel/${periodoId}/centrocusto/${centroCustoId}/analitico`)
  commit(type.SET_PERIODO,{periodo})
}
const setIndicadoresAbertos = ({commit},id) => {
  commit(type.SET_INDICADORES_ABERTOS,{id})
}
const setIndicadorSelectedId = ({commit},id) => {
  commit(type.SET_INDICADOR_SELECTED_ID,{id})
}
const SET_NOTAS = async({commit} , periodo) =>
{
    const notas = (await axios.get(`${process.env.API_PATH}/painel/${periodo}/nota`)).data
    commit(type.SET_NOTAS, {notas} )
}

export default {
  setPeriodo,
  setIndicadoresAbertos,
  SET_NOTAS,
  setIndicadorSelectedId
}



// WEBPACK FOOTER //
// ./src/features/Dashboard/store/actions.js